import React, { useEffect, useRef } from "react";
import { skills } from "../../utils/skills";
import Image from "../Atoms/Image";
import TiltCard from "../Atoms/TiltCard";
import { createSwapy } from "swapy";

interface SkillCardProps {}

const SkillCard: React.FC<SkillCardProps> = () => {
  const swapy = useRef<any>(null);
  const container = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (container.current) {
      swapy.current = createSwapy(container.current);

      swapy.current.onSwap((event: any) => {
        console.log("swap", event);
      });
    }
    return () => {
      swapy.current?.destroy();
    };
  }, []);
  return (
    <div ref={container} className="grid grid-cols-1 sm:grid-cols-3 gap-6">
      {skills.map((skill) => (
        <div key={skill.id} >
          <div
           
            className="flex justify-center h-[250px] w-full sm:h-[150px]"
          >
            <TiltCard
              key={skill.id}
              className="w-full sm:w-80 flex items-center justify-center rounded-xl overflow-hidden bg-gradient-to-br from-green-600 via-gray-700 to-green-700 transition duration-300 hover:scale-105 hover:shadow-xl"
            >
              <div className="relative flex justify-center w-100 h-1/2">
                <Image
                  alt="gallery"
                  className="inset-0 w-full sm:h-50 h-full object-cover object-center"
                  source={skill.image}
                />
              </div>
            </TiltCard>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SkillCard;
